export const MIDWAY_DOMAIN = 'midway-auth.amazon.com';
export const FEDERATED_INFO = 'federatedInfo';
export const ID_TOKEN = 'id_token';
export const STATE = 'state';
export const CHARACTER_SETS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
export const OPEN_ID = 'openid';
export const GET = 'GET';